<template>
  <div class="product-section">
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_info_title_2') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_info_text_2_1">
                <b>{{ $t('alert_system') }}</b>
                <b class="bold">SHIPPING BOARD</b>
                <b>{{ $t('sms') }}</b>
              </i18n>
            </div>
          </div>
        </div>
        <div class="image">
          <img :src="`/static/img/feature_02.jpg`" />
        </div>
      </div>
      <div class="feature right">
        <div class="image">
          <img :src="`/static/img/feature_03.png`" />
        </div>
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_info_title_3') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_info_text_3_1">
                <b class="bold">SHIPPING BOARD</b>
                <b>{{ $t('emergencies') }}</b>
                <b>{{ $t('priority') }}</b>
              </i18n>
            </div>
          </div>
        </div>
      </div>
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_info_title_4') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_info_text_4_1">
                <b class="bold">SHIPPING BOARD</b>
                <b>{{ $t('better_organizational_decisions') }}</b>
              </i18n>
              <i18n tag="p" path="product_info_text_4_2">
                <b class="bold">SHIPPING BOARD</b>
                <b>{{ $t('better_organizational_decisions') }}</b>
              </i18n>
            </div>
          </div>
        </div>
        <div class="image">
          <img :src="`/static/img/feature_04.jpg`" />
        </div>
      </div>
      <div class="feature right">
        <div class="image">
          <img :src="`/static/img/feature_05.jpg`" />
        </div>
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_info_title_5') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_info_text_5_1">
                <b>{{ $t('qr_codes') }}</b>
              </i18n>
            </div>
          </div>
        </div>
      </div>
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_info_title_6') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_info_text_6_1">
                <b>{{ $t('gallery') }}</b>
                <b>{{ $t('document_any_incidents') }}</b>
                <b>{{ $t('generate_reports') }}</b>
              </i18n>
            </div>
          </div>
        </div>
        <div class="image">
          <img :src="`/static/img/feature_06.jpg`" />
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'product-info',
  components: { },
  props: []
}
</script>
<style lang="scss">
.product-section {
  box-sizing: border-box;
  margin: 2em 0;
}
.feature {
  margin: 0 auto;
  padding: 1.5em 5%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .text{
    flex:5;
    max-width: 100%;
    box-sizing: border-box;
    padding: 2em 0;
    .text-wrapper {
      height: 100%;
      margin: auto;
      max-width: 100%;
      min-width: 20em;
      width: 35em;
      h3 {
        margin-bottom: 1em;
      }
    }
  }
  .image {
    flex:7;
    margin: 2em 0;
    min-width: 20em;
    max-width: 100%;
    width: 25em;
  }
  &.right {
    text-align: right;
    flex-wrap: wrap-reverse;
    .image {
      margin-right: 10%;
    }
  }
  &.left {
    .image {
      margin-left: 10%;
    }
  }
}

@media screen and (max-width: 950px) {
  .feature {
    .text {
      .text-wrapper {
        width: auto;
        min-width:10em;
      }
    }
    &.right {
      flex-direction: column-reverse;
      text-align: center;
      .image {
        margin-right: 0;
        width:40em;
      }
    }
    &.left {
      flex-direction: column;
      text-align: center;
      .image {
        margin-left: 0;
        width:42em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductFeatures.vue